// Module
var code = "<div class=\"vessel-event-icon\" data-bind=\"event: { mouseover: showNameToopltip, mouseout: closeTooltip}\">\n    <img style=\"margin-bottom: -5px;\" data-bind=\"attr: { src: typeImageSrc }\">\n    <!-- ko if: showText -->\n    <span data-bind=\"text: typeText\"></span>\n    <!-- /ko -->\n</div>\n";
// Exports
module.exports = code;